import { getNestedData } from "../../../util/accessors"
import { getFormattedDate } from "../../../util/helperFunctions"
import { getCurrency, formatPhone } from "../../../util/formating"

export default function getValue({ entry, accessor, type }) {
	let value = getNestedData({ object: entry, path: accessor || "" })

	if (value === undefined || value === null || typeof value === "object") value = ""
	else if (type === "boolean") value = value ? "Yes" : "No"
	else if (type === "percent") value = `${value}%`
	else if (type === "amount") value = getCurrency({ amount: value, actions: ["divide"] })
	else if (type === "date" || type === "ts") value = getFormattedDate({ date: value })
	else if (type === "phone") value = formatPhone({ phone: value })

	return value
}
